import { Component, ElementRef, HostListener, OnDestroy, OnInit, SecurityContext, ViewChild, Renderer2, TemplateRef, Output, EventEmitter, HostBinding, ViewChildren, QueryList } from '@angular/core';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { RestaurantService } from '../../services/restaurant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CartaMenu, ListaSecciones, Plato, Seccion } from 'src/app/models/dto/carta-menu';
import { AvisoImagenRestaurante, AvisoRestaurante, Restaurant } from 'src/app/models/dto/restaurant';
import { Icons } from 'src/app/models/dto/icons';
import { Options } from '@angular-slider/ngx-slider';
import { ViewportScroller } from '@angular/common';
import { UserService } from 'src/app/services/user.service';
import { TempUser } from 'src/app/models/dto/temp-user';
import { ToastrService } from 'ngx-toastr';
import { LikedProducts } from 'src/app/models/dto/liked-products';
import { LikedQualities } from 'src/app/models/dto/liked-qualities';
import { ListLikedQualities } from 'src/app/models/dto/list-liked-qualities';
import { SessionService } from 'src/app/services/session.service';

import { LoginRegisterComponent } from '../shared/login-register/login-register.component'; // Asegúrate de importar el componente secundario
import { OpenAIService } from 'src/app/services/AI/open-ai.service';
import { OpenAIImage } from 'src/app/models/dto/open-aiimage';
import { Cart, ProductsCart } from 'src/app/models/dto/cart';
import { CryptoService } from 'src/app/services/crypto.service';
import { MenuStateService } from 'src/app/services/menu-state.service';
import { DishComponent } from '../dish/dish.component';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { catchError, finalize, forkJoin, from, map, Observable, of, Subject, takeUntil } from 'rxjs';
import { MenuLanguageCode, MenuLanguagePreferenceSource, menuLanguageId, resolveMenuLanguage } from 'src/app/models/menu-language';
import { MenuLanguageService } from 'src/app/services/menu-language.service';
import { ChatHistoryMessage, ChatProduct, ChatResponse, ProductRecommendation, ProductRecommendationRequest } from 'src/app/models/dto/chat';
import { CURRENCY_OPTIONS, CurrencyDisplayState } from 'src/app/models/currency';
import { CurrencyService } from 'src/app/services/currency.service';
import { UiTranslationService } from 'src/app/services/ui-translation.service';

interface GroupedItem {
  Nombre: string;
  Descs: { Desc: string, Valores: string[] }[];
}

@Component({
  selector: 'app-info-menu',
  templateUrl: './info-menu.component.html',
  styleUrls: ['./info-menu.component.css']
})
export class InfoMenuComponent implements OnInit, OnDestroy {


  menu: any = Array<CartaMenu>();
  itemMenu: any = CartaMenu;
  icons: any = Array<Icons>();
  sections: any = Array<ListaSecciones>();
  idRestaurant: number = 0
  restaurant: any = new Restaurant(0, 0, 0, 0, "", "", "", "", 0, "", "", 0, "", "", 0, "", "", "", 0, 0, "");

  copyStorageSections: any = Array<ListaSecciones>();

  dishes: any = Array<Plato>();
  idMenu: number = 0;
  idDish: number = 0;
  idIcon: number = 0;
  // true cuando el idioma seleccionado aún no tiene traducción disponible para esta carta
  // (respuesta available=false del backend); se muestra el menú en español como fallback
  // explícito, sin tratarlo como un error.
  translationUnavailable: boolean = false;
  preferredLanguage: MenuLanguageCode = 'es';
  activeLanguage: MenuLanguageCode | null = null;
  preferenceSource: MenuLanguagePreferenceSource = 'fallback';
  quickLanguageAvailability: Record<'es' | 'en', boolean> = { es: false, en: false };
  quickLanguageChecking = false;
  quickLanguageChanging = false;
  quickLanguageMessage = '';
  private quickLanguageVersion = 0;
  @ViewChild('languageReturnFocus') languageReturnFocus?: ElementRef<HTMLElement>;
  maxDishPrice: number = 0;
  minDishPrice: number = 0;
  maxDishPriceValue: number = 0;
  didIt = false;
  loading = false;
  getLocal: boolean = false;
  cualidades: any = Array<any>();
  unidades: any = Array<any>();
  filterUnidades: any = Array<any>();
  showBooleanValue: boolean = false;
  showTextValue: boolean = false;
  showRangeValue: boolean = false;
  minValue: number = 50;
  maxValue: number = 200;

  /** Price criteria are always kept in the restaurant base currency. */
  minPriceDish: number | null = null;
  maxPriceDish: number | null = null;
  priceFilterError = '';

  IdTipoUnidadMedida: number = 0;
  IdUnidad: number = 0;

  filter: boolean = false;
  quality: boolean = false;
  cualidad: string = "";
  unidad: string = "";
  idiomaUser: any = "";
  monedaUser: any = "";
  currencyState!: CurrencyDisplayState;
  readonly currencyOptions = CURRENCY_OPTIONS;
  isInvitated: boolean = false;

  cualidadPersonal: string = "";
  unidadPersonal: string = "";
  idUnidadPersonal: number = 0;
  valorPersonal: string = "";
  showBooleanValuePersonal: boolean = false;
  showTextValuePersonal: boolean = false;
  showRangeValuePersonal: boolean = false;
  minValuePersonal: number = 50;
  maxValuePersonal: number = 200;
  max = 0;
  min = 0;

  @ViewChild('closeMenu') closeAddExpenseModal: any = ElementRef;
  @ViewChild('modalPlatos') modalPlatos: any = ElementRef;

  @ViewChild('closeModal') closeModal: any = ElementRef;
  private translateBtn: any;
  hasValues: boolean = false;
  @ViewChild('navIcon', { read: DragScrollComponent }) ds: any = DragScrollComponent;
  isfixed: boolean = false;

  @ViewChild('scroller', { read: ElementRef }) scrollerRef!: ElementRef<HTMLElement>;
  @ViewChildren('iconItem', { read: ElementRef }) iconItems!: QueryList<ElementRef<HTMLElement>>;
  private _rafLock = false;

  idMenuChange: number = 0;
  menudId: number = 0;

  todayDate = new Date();
  public isCollapsed = true;
  @ViewChild('sliderContainer') sliderContainer: ElementRef | undefined;
  listFavDishes: any = Array<Plato>;
  listLikedQualities: any = Array<ListLikedQualities>;
  @ViewChild('miModal', { static: true }) miModal: any = TemplateRef<any>;
  @ViewChild('modalProfile') modalProfile: any = TemplateRef<any>;
  @ViewChild('modalCartas') modalCartas: any = TemplateRef<any>;
  @ViewChild('modalMasFiltros') modalMoreFiltes: any = TemplateRef<any>;
  @ViewChild('modalAviso', { static: true }) modalAviso!: TemplateRef<any>;

  myProfile: boolean = true;
  email: string = "";
  @ViewChild(LoginRegisterComponent) modalLogin: any = LoginRegisterComponent;
  userInformation: any;
  platosFiltradosCualidades: any;
  isInvitatedUser: boolean = false;

  precioMaximo = 0;
  precioMinimo = 0;
  searchName: string = "";
  isFilter: boolean = false;
  isFilterQualities: boolean = false;
  isFilterText: boolean = false;
  isFilterPrice: boolean = false;
  isFilterLike: boolean = false;
  isFilterMore: boolean = false;
  changeMinMax: boolean = false;
  itemFilter: any = Array<any>;
  isBackMenu: boolean = false;
  informationRouter: any = Array<any>();

  menuId: number = 0;
  cartaId: number = 0;

  idiomas: Array<any> =
    [
      {
        value: "1",
        code: "es"
      },
      {
        value: "2",
        code: "en"
      },
      {
        value: "3",
        code: "pt"
      },
      {
        value: "4",
        code: "fr"
      },
      {
        value: "5",
        code: "it"
      },
      {
        value: "6",
        code: "zh"
      },
      {
        value: "7",
        code: "ar"
      },
      {
        value: "8",
        code: "de"
      }
    ];

  moneda: Array<any> =
    [
      {
        value: "1",
        code: "USD"
      },
      {
        value: "2",
        code: "MXN"
      },
      {
        value: "3",
        code: "CLP"
      }
    ];

  @HostBinding('class.show') isShowTop: boolean = false;

  objFilters: any = Array<any>();
  objDeleteFilters: any = Array<any>();

  objCheckedMenu: any = Array<any>();
  otherFilter: any = Array<any>();
  selectedCategory: string | null = null;
  selectedItem: any = null;

  selectedNombre: string = '';
  selectedDesc: string = '';
  selectedValue: string = '';
  showSelectedDesc: boolean = true;
  descs: { Desc: string, Valores: string[] }[] = [];
  valores: string[] = [];
  moreFilter: any = Array<any>();

  isOpenChat: boolean = false;
  messagechat: string = '';
  conversation: { sender: string, message: string, type: number, translationKey?: string, products?: ChatProduct[], loading?: boolean }[] = [];
  @ViewChild('chatContainer') chatContainer: any = ElementRef;
  showDropdownMenu: boolean = false; // Inicializar como verdadero
  idDishToGo: number = 0;
  urlImg: string = "";
  chatHistory: ChatHistoryMessage[] = [];
  private chatContextSignature = '';
  cart: any = new Cart();
  @ViewChild('dishCarousel', { static: false })
  dishCarousel!: SlickCarouselComponent;

  selectedDish: any = null;
  productRecommendations: ProductRecommendation[] = [];
  recommendationsLoading = false;
  private recommendationPublicationId = 0;
  private readonly recommendationRequest$ = new Subject<void>();
  private dishModalRef?: NgbModalRef;

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    arrows: false,
    dots: false,
    infinite: false,
    swipe: true,
    lazyLoad: 'ondemand',
    speed: 300
  };

  searchValue: string = "";
  searchDesc: string = "";

  @ViewChildren(SlickCarouselComponent) sliders!: QueryList<SlickCarouselComponent>;

  sucursalName: string = '';
  sucursalId: number | null = null;

  sucursales: any[] = [];
  showSucursalModal: boolean = false;
  option: number = 0;
  mensajeAviso = '';
  imagenesAviso: AvisoImagenRestaurante[] = [];
  indiceImagenAviso = 0;
  private avisoConsultadoClave = '';
  private avisoRequestVersion = 0;
  private avisoPresentadoPara: number | null = null;
  private avisoModalRef?: NgbModalRef;
  private cartasModalRef?: NgbModalRef;
  private readonly destroy$ = new Subject<void>();
  private readonly intervaloAvisoMs = 5000;
  private favoriteIdsCache = new Set<number>();
  private favoriteScopeKey = '';
  private favoriteRequestInFlight = false;
  private likedQualitiesCache: any[] | null = null;
  private likedQualitiesRequestInFlight = false;
  private selectedMenuIndexes: number[] = [];
  mostrarAviso = false;

  avisoSlideConfig = this.crearConfiguracionAviso(0);

  private crearConfiguracionAviso(cantidadImagenes: number) {
    const tieneNavegacion = cantidadImagenes > 1;

    return {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: tieneNavegacion,
      infinite: tieneNavegacion,
      swipe: true,
      lazyLoad: 'ondemand',
      speed: 400,
      fade: true,
      cssEase: 'ease-in-out',
      waitForAnimate: false,
      autoplay: tieneNavegacion,
      autoplaySpeed: this.intervaloAvisoMs,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false
    };
  }

  constructor(private router: Router, private _restaurantService: RestaurantService, private activatedRoute: ActivatedRoute,
    private modalService: NgbModal, private viewportScroller: ViewportScroller,
    private renderer: Renderer2, private el: ElementRef, private userService: UserService, private toastr: ToastrService,
    private sessionService: SessionService, private route: ActivatedRoute, private openAi: OpenAIService,
    private _crypto: CryptoService, private menuState: MenuStateService,
    private menuLanguageService: MenuLanguageService, private currencyService: CurrencyService,
    public i18n: UiTranslationService) {

    this.currencyState = this.currencyService.snapshot;

    this.idRestaurant = this.activatedRoute.snapshot.params?.['idRestaurant'];
    this.idMenu = this.activatedRoute.snapshot.params?.['idMenu'];
    this.idMenuChange = this.activatedRoute.snapshot.params?.['idMenu'];
    this.option = this.activatedRoute.snapshot.params?.['option'];

    this.router.getCurrentNavigation(); // Esto básicamente obtiene la navegación actual, pero como estamos en ngOnInit de AppComponent, no necesitamos hacer nada con ella.



    // if (this.idRestaurant.toString() !== localStorage.getItem("idRestaurant")) {
    //   this.getLocal = false;
    //   localStorage.setItem("idRestaurant", this.idRestaurant.toString());
    // } else {
    //   this.getLocal = true;
    // }

    if (this.router.getCurrentNavigation()?.extras.state === undefined && this.idMenu == 0 && this.idRestaurant == 0) {
      this.router.navigate(['']);
    } else {
      this.restaurant = this.router.getCurrentNavigation()?.extras.state?.["restaurant"];
      this.idDish = this.router.getCurrentNavigation()?.extras.state?.["idDish"];
      this.idMenu = this.router.getCurrentNavigation()?.extras.state?.["idMenu"];
      this.isBackMenu = this.router.getCurrentNavigation()?.extras.state?.["isBackMenu"];


      this.informationRouter = this.router.getCurrentNavigation()?.extras.state;
    }
  }

  getLocation(): void {
    if (!navigator.geolocation) {
      console.log('Geolocalización no soportada');
      this.getSucursales(0, 0);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        this.getSucursales(lat, lng);
      },
      (error) => {
        console.error('Error obteniendo ubicación:', error);
        this.handleLocationError(error);

        this.getSucursales(0, 0);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  }

  private getSucursales(lat: number, lng: number): void {
    const obj = {
      latitud: lat,
      longitud: lng,
      idComercio: this.idRestaurant
    };

    this._restaurantService.getSucursalGeoreferneciadav2(obj)
      .subscribe({
        next: (res) => {
          const response = JSON.parse(this._crypto.decrypt(res));

          this.sucursales = response;

          if (this.sucursales.length === 1) {
            this.setSucursal(this.sucursales[0]);
            return;
          }

          if (this.sucursales.length > 1) {
            this.showSucursalModal = true;
            return;
          }

          this.sucursalName = '';
          this.sucursalId = null;
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  setSucursal(sucursal: any): void {
    this.sucursalId = sucursal.Id;
    this.sucursalName = sucursal.Nombre;
    this.showSucursalModal = false;

    console.log('Sucursal seleccionada:', this.sucursalName);
  }

  closeSucursalModal(): void {
    this.showSucursalModal = false;
  }

  private handleLocationError(error: GeolocationPositionError): void {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.log('El usuario negó el permiso');
        break;

      case error.POSITION_UNAVAILABLE:
        console.log('Ubicación no disponible');
        break;

      case error.TIMEOUT:
        console.log('Tiempo de espera agotado');
        break;

      default:
        console.log('Error desconocido obteniendo ubicación');
        break;
    }
  }

  ngOnInit(): void {
    this.currencyService.state$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.currencyState = state;
        if (state.baseCurrency) this.cart.baseCurrency = state.baseCurrency;
      });

    this.userInformation = JSON.parse(this.sessionService.getData('userInformation'));
    if (!this.userInformation) {
      // Sin sesión registrada: usa la preferencia de idioma/moneda guardada como invitado, si existe.
      const invitatedData = this.sessionService.getData('invitatedUserInformation');
      this.userInformation = invitatedData ? JSON.parse(invitatedData) : null;
    }
    const initialLanguage = this.menuLanguageService.getPreference(this.userInformation?.lenguajeType);
    this.preferredLanguage = initialLanguage.preferredLanguage;
    this.preferenceSource = initialLanguage.preferenceSource;
    this.menuLanguageService.activate(this.preferredLanguage);

    this.route.paramMap.subscribe(pm => {
      const nextRestaurant = Number(pm.get('idRestaurant'));
      if (this.idRestaurant && this.idRestaurant !== nextRestaurant) {
        this.avisoRequestVersion++;
        this.avisoConsultadoClave = '';
        this.avisoPresentadoPara = null;
        this.mensajeAviso = '';
        this.imagenesAviso = [];
        this.limpiarAvisoActivo();
      }
      this.idRestaurant = nextRestaurant;
      this.idMenu = Number(pm.get('idMenu'));
      this.cargarAvisoRestaurante(this.preferredLanguage);
    });

    this.loading = true;
    setTimeout(() => {
      if (this.idMenu > 0 || this.idRestaurant > 0) {
        this._restaurantService.getDetailRestaurants(this.idRestaurant).subscribe((data: any) => {
          this.restaurant = data;
          this.initializeCurrency();
          this.initialConfiguration();
          this.getLocation();

        });
      } else {
        this.restaurant = this.router.getCurrentNavigation()?.extras.state?.["restaurant"];
        this.initializeCurrency();
        this.initialConfiguration();
        this.getLocation();
      }
    }, 600)
    window.addEventListener('scroll', () => {
      this.onWindowScroll();
    });
    this.conversation.push({ sender: 'server', message: '', translationKey: 'chat.welcome', type: 1 });

  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event: any) {
    this.route.queryParams.subscribe(queryParams => {
      // Access query parameters
      this.menuId = queryParams['idRestaurant'];
      this.cartaId = queryParams['idMenu'];
      // Do something with param1


      this.router.navigate(['/menu/' + this.menuId + '/' + this.cartaId], { replaceUrl: true }).then()
    });
  }

  onWindowScroll() {
    if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
      this.isShowTop = true;
    } else {
      this.isShowTop = false;
    }
  }

  scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  initialConfiguration() {
    if (this.isBackMenu) {
      this.sections = this.informationRouter.sections;
      this.dishes = this.informationRouter.dishes;
      this.copyStorageSections = this.informationRouter.copyMenu;
      this.restaurant = this.informationRouter.restaurant;
      this.isFilter = this.informationRouter.hasFilter;
      this.menudId = this.informationRouter.menudId;
      this.icons = this.informationRouter.icon;

      this.loading = false;
      let dishFilters: any = []
      this.dishes.forEach((dish: any) => {
        dish.descCualidades.forEach((cualidad: any) => {
          dishFilters.push(cualidad)
        });
      });

      this.setInitialOtherFilters(dishFilters);
      this.goDish(this.idDish);

    } else {
      this.getMenu();
    }

    this._restaurantService.getCualidades().subscribe((data: any) => {
      this.cualidades = data;
    });


    this._restaurantService.getUnidades().subscribe((data: any) => {
      this.unidades = data;
    });
  }

  private cargarAvisoRestaurante(language: MenuLanguageCode = this.preferredLanguage): void {
    if (!this.idRestaurant || !this._restaurantService?.getAvisoRestaurantev2) return;
    const requestKey = `${this.idRestaurant}:${language}`;
    if (this.avisoConsultadoClave === requestKey) return;
    this.avisoConsultadoClave = requestKey;
    const requestVersion = ++this.avisoRequestVersion;
    const restaurantId = this.idRestaurant;

    this._restaurantService.getAvisoRestaurantev2(restaurantId, language).subscribe({
      next: (response: any) => {
        if (requestVersion !== this.avisoRequestVersion || restaurantId !== this.idRestaurant) return;
        let aviso: AvisoRestaurante;
        try {
          aviso = JSON.parse(this._crypto.decrypt(response));
        } catch {
          this.avisoConsultadoClave = '';
          return;
        }

        this.mensajeAviso = (aviso?.AvisoEnCatalogos || '').trim();
        const avisoYaPresentado = this.avisoPresentadoPara === restaurantId;
        if (!avisoYaPresentado) {
          this.imagenesAviso = (aviso?.ImagenesAviso || [])
            .filter(imagen => !!imagen?.UrlImagen);
          this.indiceImagenAviso = 0;
          this.avisoSlideConfig = this.crearConfiguracionAviso(this.imagenesAviso.length);
        }

        if (this.imagenesAviso.length > 3) {
          console.warn('El aviso del restaurante contiene más de 3 imágenes.');
        }

        if (!this.mensajeAviso && this.imagenesAviso.length === 0) {
          if (!avisoYaPresentado) this.limpiarAvisoActivo();
          return;
        }

        // Un cambio de idioma actualiza el texto del aviso visible, pero conserva
        // el modal, la imagen actual y el estado de visto/cerrado.
        if (avisoYaPresentado) return;

        this.limpiarAvisoActivo();
        this.avisoPresentadoPara = restaurantId;
        this.mostrarAviso = true;
        const modalRef = this.modalService.open(this.modalAviso, {
          centered: true,
          scrollable: true,
          windowClass: 'aviso-restaurante-modal',
          backdropClass: 'aviso-restaurante-backdrop',
          backdrop: 'static',
          keyboard: false
        });
        this.avisoModalRef = modalRef;

        modalRef.result.then(
          () => this.finalizarAvisoModal(modalRef),
          () => this.finalizarAvisoModal(modalRef)
        );
      },
      error: () => {
        if (requestVersion !== this.avisoRequestVersion) return;
        this.avisoConsultadoClave = '';
        if (this.avisoPresentadoPara !== restaurantId) this.limpiarAvisoActivo();
        // El aviso es complementario; la carga de la carta continúa sin mostrar error al comensal.
      }
    });
  }

  private activarIdiomaExperiencia(language: MenuLanguageCode,
    source: MenuLanguagePreferenceSource): void {
    const previousLanguage = this.preferredLanguage;
    const currentHistory = this.chatHistory || [];
    const currentConversation = this.conversation || [];
    const hasConversationContext = currentHistory.length > 0
      || currentConversation.some(message => message.sender === 'user');

    this.preferredLanguage = language;
    this.preferenceSource = source;

    if (previousLanguage !== language && hasConversationContext) {
      this.chatHistory = [];
      this.chatContextSignature = '';
      this.conversation = currentConversation.filter(message => !message.loading);
      this.conversation.push({
        sender: 'server',
        message: '',
        translationKey: 'chat.contextReset',
        type: 1
      });
    }

    this.menuLanguageService.activate(language);
    this.cargarAvisoRestaurante(language);
  }

  cerrarAviso(modal: any): void {
    this.mostrarAviso = false;
    modal.close('cerrar');
  }

  cambioImagenAviso(event: { currentSlide: number }): void {
    this.indiceImagenAviso = event.currentSlide;
  }

  ocultarImagenAviso(imagen: AvisoImagenRestaurante): void {
    this.imagenesAviso = this.imagenesAviso.filter(item => item !== imagen);
    this.indiceImagenAviso = Math.min(this.indiceImagenAviso, Math.max(0, this.imagenesAviso.length - 1));
  }

  private finalizarAvisoModal(modalRef: NgbModalRef): void {
    if (this.avisoModalRef !== modalRef) return;
    this.mostrarAviso = false;
    this.avisoModalRef = undefined;
  }

  private limpiarAvisoActivo(): void {
    this.mostrarAviso = false;
    const modalRef = this.avisoModalRef;
    this.avisoModalRef = undefined;
    modalRef?.dismiss('aviso-no-disponible');
  }

  ngOnDestroy(): void {
    this.limpiarAvisoActivo();
    this.recommendationRequest$.next();
    this.recommendationRequest$.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCurrencyChange(currency: string): void {
    this.currencyService.select(currency).pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Price limits remain stored in the base currency. Reapplying is safe and
      // keeps every other active criterion intact while the displayed limits
      // are derived from the new quote.
      if (this.isFilterPrice) this.applyAllFiltersUnified();
    });
  }

  priceInSelectedCurrency(originalPrice: number): number {
    return this.currencyService.convert(originalPrice, this.currencyState);
  }

  priceFilterValue(option: 1 | 2): number | null {
    const value = option === 1 ? this.minPriceDish : this.maxPriceDish;
    return value === null ? null : this.priceInSelectedCurrency(value);
  }

  get currentFilterCurrency(): string {
    return this.currencyState.selectedCurrency || this.currencyState.baseCurrency || '';
  }

  get visibleResultCount(): number {
    return this.dishes.filter((dish: any) => dish?.ControlaInventario !== 3).length;
  }

  get hasActiveFilters(): boolean {
    return !!(
      this.isFilterLike ||
      this.isFilterQualities ||
      this.isFilterMore ||
      this.isFilterPrice ||
      this.normalizeFilterText(this.searchName).length
    );
  }

  get currencyLocale(): string {
    const locales: Record<MenuLanguageCode, string> = {
      es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR',
      it: 'it-IT', zh: 'zh-CN', ar: 'ar', de: 'de-DE'
    };
    return locales[this.preferredLanguage] || 'es-CL';
  }

  formatRateTimestamp(value: string | null): string {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(this.currencyLocale, {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit'
    }).format(date);
  }

  private initializeCurrency(): void {
    const restaurantId = Number(this.restaurant?.IdComercio || this.idRestaurant);
    if (restaurantId > 0)
      this.currencyService.initialize(restaurantId).pipe(takeUntil(this.destroy$)).subscribe();
  }

  getMenu(language?: MenuLanguageCode) {
    // Invalidates an in-flight header selection if the profile starts another load.
    this.quickLanguageVersion++;
    this.quickLanguageChanging = false;
    this.quickLanguageChecking = false;
    this.quickLanguageAvailability = { es: false, en: false };
    this.quickLanguageMessage = '';
    this.translationUnavailable = false;
    this.loading = true;

    // option=0 no contiene un idCarta: el backend localiza el listado completo
    // del restaurante, por lo que solo se detecta la preferencia y se hace una carga.
    if (Number(this.option) === 0) {
      const preference = language
        ? { preferredLanguage: language, preferenceSource: 'manual' as MenuLanguagePreferenceSource }
        : this.menuLanguageService.getPreference(this.userInformation?.lenguajeType);
      this.activarIdiomaExperiencia(preference.preferredLanguage, preference.preferenceSource);
      this.fetchMenu(0, this.preferredLanguage);
      return;
    }

    // option=1 contiene un idCarta real. option=2 contiene una sucursal y option=3
    // conserva su semántica actual hasta que el contrato QR esté confirmado.
    if (Number(this.option) !== 1 || !this.idMenu) {
      const preference = language
        ? { preferredLanguage: language, preferenceSource: 'manual' as MenuLanguagePreferenceSource }
        : this.menuLanguageService.getPreference(this.userInformation?.lenguajeType);
      this.activarIdiomaExperiencia(
        preference.preferredLanguage, preference.preferenceSource);
      this.fetchMenu(this.idMenu, this.preferredLanguage);
      return;
    }

    const preference = language
      ? { preferredLanguage: language, preferenceSource: 'manual' as MenuLanguagePreferenceSource }
      : this.menuLanguageService.getPreference(this.userInformation?.lenguajeType);
    this.activarIdiomaExperiencia(preference.preferredLanguage, preference.preferenceSource);
    this.resolveAndFetchMenu(this.idMenu, this.preferredLanguage, this.preferredLanguage !== 'es');
  }

  private resolveAndFetchMenu(idCartaInicial: number, language: MenuLanguageCode, allowSpanishFallback: boolean): void {
    this._restaurantService.resolveCartaLanguagev2(idCartaInicial, language).subscribe({
      next: (resolution) => {
        if (resolution.available && resolution.idCarta && resolution.idCarta > 0) {
          this.fetchMenu(resolution.idCarta, language);
        } else if (allowSpanishFallback) {
          this.translationUnavailable = true;
          this.resolveAndFetchMenu(idCartaInicial, 'es', false);
        } else {
          this.showStableEmptyMenu();
        }
      },
      error: (error) => {
        if (allowSpanishFallback) {
          this.translationUnavailable = true;
          this.resolveAndFetchMenu(idCartaInicial, 'es', false);
          return;
        }
        this.toastr.error(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
        this.showStableEmptyMenu();
      }
    });
  }

  private fetchMenu(idMenuActual: number, language: MenuLanguageCode) {
    this._restaurantService.getMenuV2(this.idRestaurant, idMenuActual, language, this.option).subscribe({
      next: (res: any) => {
        let response: unknown;
        try {
          response = JSON.parse(this._crypto.decrypt(res));
        } catch {
          this.showStableEmptyMenu();
          return;
        }

        if (!Array.isArray(response) || response.length === 0) {
          this.showStableEmptyMenu();
          return;
        }

        // option=0 puede mezclar el idioma solicitado con variantes ES de fallback.
        // Sin idioma efectivo por carta en el DTO, no se afirma un idioma activo
        // para este flujo; las demás opciones conservan su comportamiento previo.
        this.activeLanguage = Number(this.option) === 0 ? null : language;
        this.processMenu(response);
        this.refreshQuickLanguageAvailability();
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        if (error.status === 401) {
          this.toastr.error(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
        } else if (error.status !== 200) {
          this.toastr.error(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
        }
      }
    });
  }

  private showStableEmptyMenu(): void {
    this.loading = false;
    this.activeLanguage = null;
    this.menu = [];
    this.itemMenu = null;
    this.sections = [];
    this.icons = [];
    this.dishes = [];
    this.copyStorageSections = [];
    this.refreshQuickLanguageAvailability();
  }

  get showQuickLanguageSwitch(): boolean {
    return ['pt', 'fr', 'it', 'zh', 'ar', 'de'].includes(this.preferredLanguage);
  }

  private resolveQuickLanguage(language: 'es' | 'en'): Observable<number[]> {
    const ids: number[] = this.menu.map((carta: any) => Number(carta.idCarta));
    if (!ids.length || ids.some((id: number) => !Number.isInteger(id) || id <= 0)) return of([]);
    // Resolve real carta IDs, never the branch/QR parameter. The resolver guarantees
    // the same logical catalog, including when option=0/2/3 returns several cartas.
    return forkJoin(ids.map((id: number) =>
      this._restaurantService.resolveCartaLanguagev2(id, language))).pipe(
      map(resolutions => resolutions.every(result => result.available && Number(result.idCarta) > 0
        && result.idioma === language)
        ? resolutions.map(result => Number(result.idCarta)) : []),
      catchError(() => of([]))
    );
  }

  private refreshQuickLanguageAvailability(): void {
    const version = ++this.quickLanguageVersion;
    this.quickLanguageAvailability = { es: false, en: false };
    this.quickLanguageChecking = false;
    if (!this.showQuickLanguageSwitch || !this.menu.length) return;
    this.quickLanguageChecking = true;
    forkJoin({ es: this.resolveQuickLanguage('es'), en: this.resolveQuickLanguage('en') })
      .pipe(takeUntil(this.destroy$)).subscribe(result => {
        if (version !== this.quickLanguageVersion) return;
        this.quickLanguageChecking = false;
        this.quickLanguageAvailability = { es: result.es.length > 0, en: result.en.length > 0 };
        this.quickLanguageMessage = result.es.length && result.en.length ? ''
          : 'Idioma no disponible para todas las cartas actuales. Elige una opción habilitada; tu carta se conserva. / Language unavailable for all current menus. Choose an enabled option; your menu is kept.';
      });
  }

  switchQuickLanguage(language: 'es' | 'en'): void {
    if (!this.showQuickLanguageSwitch || this.quickLanguageChecking || this.quickLanguageChanging
      || !this.quickLanguageAvailability[language]) return;
    const version = ++this.quickLanguageVersion;
    this.quickLanguageChanging = true;
    this.quickLanguageMessage = '';
    const fail = () => {
      if (version !== this.quickLanguageVersion) return;
      this.quickLanguageChanging = false;
      this.quickLanguageMessage = 'No se pudo cambiar el idioma. Tu carta se conserva; intenta otra opción. / Could not change language. Your menu is kept; try another option.';
    };
    // Recheck before loading. Nothing in the current experience changes until the
    // target response has been validated, so missing/stale translations stay safe.
    this.resolveQuickLanguage(language).pipe(takeUntil(this.destroy$)).subscribe(ids => {
      if (version !== this.quickLanguageVersion) return;
      if (!ids.length) { fail(); this.quickLanguageAvailability[language] = false; return; }
      const targetId = Number(this.option) === 1 ? ids[0] : this.idMenu;
      this._restaurantService.getMenuV2(this.idRestaurant, targetId, language, this.option)
        .pipe(takeUntil(this.destroy$)).subscribe({
          next: (encrypted: any) => {
            if (version !== this.quickLanguageVersion) return;
            let response: any;
            try { response = JSON.parse(this._crypto.decrypt(encrypted)); }
            catch { fail(); return; }
            if (!Array.isArray(response)) { fail(); return; }
            // Preserve the current logical menus, selection and order even if a
            // different language's list has another order or additional entries.
            const ordered = ids.map(id => response.find((carta: any) => Number(carta.idCarta) === id));
            if (ordered.some(carta => !carta?.secciones?.some((group: any) => group.Secciones?.length))) {
              fail(); return;
            }
            this.activarIdiomaExperiencia(language, 'manual');
            this.menuLanguageService.setExplicitPreference(language);
            this.idiomaUser = menuLanguageId(language);
            this.activeLanguage = language;
            this.translationUnavailable = false;
            this.quickLanguageChanging = false;
            this.processMenu(ordered, true);
            // The recovery buttons disappear in ES/EN; keep keyboard focus in
            // the header instead of leaving it on a removed element.
            this.languageReturnFocus?.nativeElement.focus();
          },
          error: fail
        });
    });
  }

  cargarPlatosPorSeccion() {
    const requests: Observable<{ seccion: any; platos: any[] }>[] = [];

    for (const menu of this.menu) {
      for (const grupo of menu.secciones) {
        for (const seccion of grupo.Secciones) {
          seccion.loading = true;

          const request$ = this._restaurantService.ObtienePlatosPorSeccionv2(this.idRestaurant, seccion.IdSeccion).pipe(
            map((res: any) => {
              const platos = JSON.parse(this._crypto.decrypt(res));
              return { seccion, platos };
            }),
            catchError((error) => {
              this.toastr.error(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
              return of({ seccion, platos: [] });
            })
          );

          requests.push(request$);
        }
      }
    }

    if (requests.length === 0) {
      this.rebuildAuthorizedProductScope();
      this.loading = false;
      return;
    }

    forkJoin(requests).subscribe((results) => {
        for (const { seccion, platos } of results) {
          seccion.Platos = platos;
          seccion.loading = false;
        }

        this.rebuildAuthorizedProductScope();
        this.getLikes();
        this.loading = false;
      });
  }

  processMenu(response: any, preserveSelection = false) {
    if (!Array.isArray(response) || response.length === 0) {
      this.showStableEmptyMenu();
      return;
    }
    const previousSelectedIndexes = this.menu
      .map((carta: any, index: number) => carta?.check ? index : -1)
      .filter((index: number) => index >= 0);

    this.menu = response;
    this.objCheckedMenu = [];
    this.selectedMenuIndexes = previousSelectedIndexes.length
      ? previousSelectedIndexes.filter((index: number) => index < response.length)
      : response.map((_: any, index: number) => index);

    response.forEach((carta: any, index: number) => {
      carta.check = Number(this.option) === 0 || preserveSelection
        ? this.selectedMenuIndexes.includes(index)
        : index === 0;
      if (carta.check) this.objCheckedMenu.push(Number(carta.idCarta));
    });

    if (response.length > 1) {

      let showModal = localStorage.getItem("modalCartas");


      if (!showModal) {

        const cartasModalRef = this.modalService.open(this.modalCartas, { centered: true });
        this.cartasModalRef = cartasModalRef;
        cartasModalRef.result.then(
          () => { if (this.cartasModalRef === cartasModalRef) this.cartasModalRef = undefined; },
          () => { if (this.cartasModalRef === cartasModalRef) this.cartasModalRef = undefined; }
        );
      }


    }

    this.itemMenu = this.menu.find((carta: any) => carta.check) || this.menu[0];
    this.menudId = this.itemMenu.idCarta;
    this.sections = [];
    this.icons = [];
    this.dishes = [];
    this.copyStorageSections = [];
    this.invalidateFavoriteCache();
    this.cargarPlatosPorSeccion();
  }

  private rebuildAuthorizedProductScope(): void {
    const selectedIds = new Set(this.getSelectedMenuIds());
    const selectedMenus = this.menu.filter((carta: any) => selectedIds.has(Number(carta.idCarta)));
    const sections: any[] = [];
    const seenProducts = new Set<string>();

    for (const carta of selectedMenus) {
      for (const group of (carta?.secciones || [])) {
        const clonedGroup = JSON.parse(JSON.stringify(group));
        for (const section of (clonedGroup?.Secciones || [])) {
          section.Platos = (section.Platos || []).filter((dish: any) => {
            const identity = this.productIdentity(dish);
            if (identity && seenProducts.has(identity)) return false;
            if (identity) seenProducts.add(identity);
            dish._menuId = Number(carta.idCarta);
            return true;
          });
        }
        sections.push(clonedGroup);
      }
    }

    this.sections = sections;
    this.copyStorageSections = JSON.parse(JSON.stringify(sections));
    this.rebuildVisibleDishIndex();
    this.rebuildSectionIcons();
    this.getMinMaxPrice();

    const qualities = this.dishes.flatMap((dish: any) => this.getDishQualities(dish));
    this.setInitialOtherFilters(qualities);

    if (this.hasActiveFilters) this.applyAllFiltersUnified();
  }

  private rebuildVisibleDishIndex(): void {
    const seen = new Set<string>();
    this.dishes = [];
    for (const group of (this.sections || [])) {
      for (const section of (group?.Secciones || [])) {
        for (const dish of (section?.Platos || [])) {
          const identity = this.productIdentity(dish);
          if (!identity || !seen.has(identity)) {
            if (identity) seen.add(identity);
            this.dishes.push(dish);
          }
        }
      }
    }
  }

  private rebuildSectionIcons(): void {
    this.icons = [];
    for (const group of (this.sections || [])) {
      for (const section of (group?.Secciones || [])) {
        if (section?.TipoSeccion !== 1) continue;
        const icon = new Icons(0, '', '', false);
        icon.id = section.Pos;
        icon.name = section.NombreSeccion;
        icon.icon = section.IconOn;
        this.icons.push(icon);
      }
    }
  }

  private getSelectedMenuIds(): number[] {
    if (Number(this.option) !== 0) {
      const active = Number(this.itemMenu?.idCarta || this.menudId || this.idMenu);
      return active > 0 ? [active] : [];
    }

    return (this.objCheckedMenu || [])
      .map((id: any) => Number(id))
      .filter((id: number, index: number, values: number[]) => id > 0 && values.indexOf(id) === index);
  }

  private productIdentity(dish: any): string {
    const publicationId = Number(dish?.IdPlato);
    if (Number.isFinite(publicationId) && publicationId > 0) return `publication:${publicationId}`;
    const productId = Number(dish?.IDComercio);
    return Number.isFinite(productId) && productId > 0 ? `product:${productId}` : '';
  }

  setInitialOtherFilters(dishFilters: any) {
    this.otherFilter = this.groupItems(dishFilters);
    if (this.otherFilter.length > 0) {
      this.selectedNombre = this.otherFilter[0].Nombre;
      this.onNombreChange();
    } else {
      this.selectedNombre = '';
      this.selectedDesc = '';
      this.selectedValue = '';
      this.descs = [];
      this.valores = [];
    }
  }

  groupItems(items: any[]): GroupedItem[] {
    const grouped = items.reduce((acc, item) => {
      if (!item?.Nombre || item?.Valor === null || item?.Valor === undefined || item?.Valor === '') {
        return acc;
      }

      // Verifica si el grupo ya existe
      let group = acc.find((g: any) => g.Nombre === item.Nombre);
      if (!group) {
        group = { Nombre: item.Nombre, Descs: [] };
        acc.push(group);
      }

      // Verifica si la descripción ya existe dentro del grupo
      const description = item.Desc || '';
      let descGroup = group.Descs.find((d: any) => d.Desc === description);
      if (!descGroup) {
        descGroup = { Desc: description, Valores: [] };
        group.Descs.push(descGroup);
      }

      // Agrega el valor al grupo de descripción
      descGroup.Valores.push(item.Valor);

      return acc;
    }, [] as GroupedItem[]);

    // Ordenar los valores de cada descripción
    grouped.forEach((group: any) => {
      group.Descs.forEach((descGroup: any) => {
        let valores = descGroup.Valores;
        if (parseInt(valores[0])) {
          valores = valores.map(Number).sort((a: any, b: any) => a - b);
          // Eliminar duplicados
          valores = valores.filter((num: any, index: any) => valores.indexOf(num) === index);
          descGroup.Valores = valores;
        } else {
          valores = valores.filter((letra: any, index: any) => valores.indexOf(letra) === index);
          descGroup.Valores = valores;
        }

      });
    });

    return grouped;
  }

  onNombreChange(): void {
    this.showSelectedDesc = true;
    const selectedGroup = this.otherFilter.find((group: any) => group.Nombre === this.selectedNombre);
    this.descs = selectedGroup ? selectedGroup.Descs : [];

    if (!this.descs.length) {
      this.selectedDesc = '';
      this.selectedValue = '';
      this.valores = [];
      return;
    }

    this.selectedDesc = this.descs[0].Desc;
    this.onDescChange();

    this.showSelectedDesc = this.selectedDesc.length > 0;

  }

  onDescChange(): void {
    const selectedDescGroup = this.descs.find(desc => desc.Desc === this.selectedDesc);
    this.valores = selectedDescGroup ? selectedDescGroup.Valores : [];
    this.selectedValue = this.valores[0];
  }

  addMoreFilter() {
    if (!this.selectedNombre || this.selectedValue === null || this.selectedValue === undefined) return;
    const valueFilter = {
      cualidad: "",
      unidad: "",
      valor: ""
    };

    valueFilter.cualidad = this.selectedNombre;
    valueFilter.valor = this.selectedValue;

    valueFilter.unidad = this.selectedDesc || '';

    const exists = this.moreFilter.some((filter: any) =>
      filter.cualidad === valueFilter.cualidad &&
      filter.unidad === valueFilter.unidad &&
      `${filter.valor}` === `${valueFilter.valor}`);
    if (!exists) this.moreFilter.push(valueFilter);
    this.isFilterMore = true;
    if (Array.isArray(this.copyStorageSections)) this.applyAllFiltersUnified();
  }

  deleteMoreFilter(index: number) {
    this.moreFilter.splice(index, 1);

    if (this.moreFilter.length == 0) {
      this.isFilterMore = false;
    }
    if (Array.isArray(this.copyStorageSections)) this.applyAllFiltersUnified();
  }

  getMinMaxPrice() {
    const prices = this.dishes
      .filter((dish: any) => dish?.ControlaInventario !== 3)
      .map((dish: any) => Number(dish?.Precio))
      .filter((price: number) => Number.isFinite(price));
    this.precioMinimo = prices.length ? Math.min(...prices) : 0;
    this.precioMaximo = prices.length ? Math.max(...prices) : 0;
  }

  changeMenu(id: number) {
    this.idMenu = id;
    this.objCheckedMenu = [id];
    this.menu.forEach((carta: any) => carta.check = Number(carta.idCarta) === Number(id));
    this.itemMenu = this.menu.find((carta: any) => carta.check) || this.menu[0];
    this.menudId = Number(this.itemMenu?.idCarta || id);
    this.invalidateFavoriteCache();
    this.rebuildAuthorizedProductScope();
    this.getLikes();
  }

  setMenu(id: number, op: number = 0) {
    let index = this.objCheckedMenu.findIndex((x: any) => x == id);
    if (index !== -1) {
      this.objCheckedMenu.splice(index, 1);
    } else {
      this.objCheckedMenu.push(id);
    }

    if (op !== 0) {
      const eventoSimulado = new Event('eventoPersonalizado');

      this.checkedMenus(eventoSimulado);
    }
  }

  checkedMenus(event: Event) {
    event.stopPropagation();
    this.loading = true;
    this.menu.forEach((carta: any, index: number) => {
      carta.check = this.objCheckedMenu.map(Number).includes(Number(carta.idCarta));
      if (carta.check) this.selectedMenuIndexes.push(index);
    });
    this.selectedMenuIndexes = this.menu
      .map((carta: any, index: number) => carta.check ? index : -1)
      .filter((index: number) => index >= 0);
    this.itemMenu = this.menu.find((carta: any) => carta.check) || this.menu[0] || null;
    this.menudId = Number(this.itemMenu?.idCarta || 0);
    this.invalidateFavoriteCache();
    this.rebuildAuthorizedProductScope();
    this.getLikes();

    this.cartasModalRef?.dismiss('seleccion-cartas');
    this.cartasModalRef = undefined;
    localStorage.setItem("modalCartas", "true")
    this.loading = false;
  }

  setPriceFilter(value: any, option: number) {
    const rawValue = value?.value ?? value;
    const isEmpty = rawValue === '' || rawValue === null || rawValue === undefined;
    const displayedValue = isEmpty ? null : Number(rawValue);
    const rate = Number(this.currencyState.rate);
    const originalValue = displayedValue === null
      ? null
      : Number.isFinite(displayedValue) && Number.isFinite(rate) && rate > 0
        ? displayedValue / rate
        : Number.NaN;

    if (option === 1) this.minPriceDish = originalValue;
    if (option === 2) this.maxPriceDish = originalValue;
    this.changeMinMax = this.minPriceDish !== null || this.maxPriceDish !== null;
    this.isFilterPrice = this.changeMinMax;
    if (this.validatePriceRange() && Array.isArray(this.copyStorageSections)) this.applyAllFiltersUnified();
  }

  saveFilters(op: number, value: number) {
    if (op == 1) {
      switch (value) {
        case 1:
          this.isFilterLike = !this.isFilterLike;
          break;
        case 2:
          this.isFilterQualities = !this.isFilterQualities;
          break;
      }
      if (Array.isArray(this.copyStorageSections)) this.applyAllFiltersUnified();
    } else {
      switch (value) {
        case 0:
          this.searchName = '';
          this.isFilterText = false;
          break;
        case 1:

          this.isFilterLike = false;
          break;
        case 2:
          this.isFilterQualities = false;
          break;
        case 3:
          this.isFilterPrice = false;
          this.changeMinMax = false;
          this.minPriceDish = null;
          this.maxPriceDish = null;
          this.priceFilterError = '';
          break
        case 4:
          this.isFilterMore = false;
          this.moreFilter = [];
          break;
      }
      this.applyAllFiltersUnified();
    }
  }

  appyFilters() {
    if (!this.validatePriceRange()) return;
    this.isFilterText = this.normalizeFilterText(this.searchName).length > 0;
    this.isFilterPrice = this.minPriceDish !== null || this.maxPriceDish !== null;
    this.isFilterMore = this.moreFilter.length > 0;
    this.showDropdownMenu = false;
    if (Array.isArray(this.copyStorageSections)) this.applyAllFiltersUnified();
    this.objFilters = [];
    this.objDeleteFilters = [];
  }

  setFilters(op: number, bot: boolean = false, cualidades: any = [], nombres: string[] = []) {
    this.showDropdownMenu = false;
    if (this.userInformation?.email === undefined && (op == 1 || op == 2)) {

      this.toastr.error(this.i18n.translate('messages.loginRequiredFilters'));
      this.modalLogin.showModal();
      this.isFilterQualities = false;
      this.isFilterLike = false;
    } else {
      let copySections: any = [];
      if (op == 0 || op == 1 || op == 2 || op == 3) {

        copySections = this.setSectionDishes();
      }
      switch (op) {
        case 0:
          if (this.searchName !== "" && !this.changeMinMax) {
            this.isFilterText = true;
          } else if (this.changeMinMax && this.searchName !== "") {
            this.isFilterText = true;
            this.isFilterPrice = true;
          }
          else if (this.changeMinMax) {
            this.isFilterPrice = true;
          }
          for (let i = 0; i < copySections.length; i++) {
            for (let j = 0; j < copySections[i].Secciones.length; j++) {

              for (let k = 0; k < copySections[i].Secciones[j].Platos.length; k++) {

                if (this.searchName !== "" && !this.changeMinMax) {
                  this.isFilterText = true;
                  if (copySections[i].Secciones[j].Platos[k].Nombre.toLowerCase().includes(this.searchName.toLowerCase()) || copySections[i].Secciones[j].Platos[k].Descripcion.toLowerCase().includes(this.searchName.toLowerCase())) {
                    this.searchName.toLowerCase().includes(copySections[i].Secciones[j].Platos[k].Nombre.toLowerCase())
                    this.sections[i].Secciones[j].Platos.push(copySections[i].Secciones[j].Platos[k]);
                    this.dishes.push(copySections[i].Secciones[j].Platos[k]);
                    if (this.idDishToGo == 0) {
                      this.idDishToGo = this.sections[i].Secciones[j].Pos;
                    }
                  }
                } else if (this.changeMinMax && this.searchName !== "") {
                  this.isFilterText = true;
                  this.isFilterPrice = true;
                  if (copySections[i].Secciones[j].Platos[k].Nombre.toLowerCase().includes(this.searchName.toLowerCase()) || copySections[i].Secciones[j].Platos[k].Descripcion.toLowerCase().includes(this.searchName.toLowerCase())) {
                    if (copySections[i].Secciones[j].Platos[k].Precio >= (this.minPriceDish ?? Number.NEGATIVE_INFINITY) && copySections[i].Secciones[j].Platos[k].Precio <= (this.maxPriceDish ?? Number.POSITIVE_INFINITY)) {
                      this.sections[i].Secciones[j].Platos.push(copySections[i].Secciones[j].Platos[k]);
                      this.dishes.push(copySections[i].Secciones[j].Platos[k])
                      if (this.idDishToGo == 0) {
                        this.idDishToGo = this.sections[i].Secciones[j].Pos;
                      }
                    }
                  }
                }
                else if (this.changeMinMax) {
                  this.isFilterPrice = true;
                  if (copySections[i].Secciones[j].Platos[k].Precio >= (this.minPriceDish ?? Number.NEGATIVE_INFINITY) && copySections[i].Secciones[j].Platos[k].Precio <= (this.maxPriceDish ?? Number.POSITIVE_INFINITY)) {
                    this.sections[i].Secciones[j].Platos.push(copySections[i].Secciones[j].Platos[k]);
                    this.dishes.push(copySections[i].Secciones[j].Platos[k])
                    if (this.idDishToGo == 0) {
                      this.idDishToGo = this.sections[i].Secciones[j].Pos;
                    }
                  }
                }
              }
            }
          }
          break;
        case 1:
          if (this.userInformation?.email !== undefined) {

            this.isFilterLike = true;
            this.userService.getLikedProductsv2(this.userInformation.email, this.menudId).subscribe({
              next: (res: any) => {

                this.loading = false;
                const response = JSON.parse(this._crypto.decrypt(res));

                for (let i = 0; i < copySections.length; i++) {
                  for (let j = 0; j < copySections[i].Secciones.length; j++) {

                    for (let k = 0; k < copySections[i].Secciones[j].Platos.length; k++) {
                      response.forEach((id: number) => {
                        if (copySections[i].Secciones[j].Platos[k].IDComercio == id) {
                          copySections[i].Secciones[j].Platos[k].Liked = true;
                          this.sections[i].Secciones[j].Platos.push(copySections[i].Secciones[j].Platos[k]);
                          this.dishes.push(copySections[i].Secciones[j].Platos[k])

                        }
                      });
                    }
                  }
                }
                this.loading = false;
              },
              error: (error) => {
                this.loading = false;
                if (error.status === 401) {
                  this.toastr.error(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
                } else if (error.status !== 200) {
                  this.toastr.error(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
                }
              }


            });
          } else {
            this.toastr.error(this.i18n.translate('messages.loginRequiredAction'));
          }
          break;
        case 2:
          this.listLikedQualities = [];
          if (this.userInformation?.email !== undefined) {
            this.userService.getLikedQualities(this.userInformation.email).subscribe((response: Array<ListLikedQualities>) => {
              if (response) {
                this.listLikedQualities = response;
                this.isFilterQualities = true;
                this.isFilter = true;
                // Filtrar platos que cumplen con las condiciones en todas las Secciones
                this.filtrarPlatosConCondiciones(this.listLikedQualities, copySections);
                this.modalService.dismissAll(this.miModal);
                this.modalService.dismissAll(this.modalProfile)
              } else {
                this.toastr.error(this.i18n.translate('menu.none'));
              }
            });
          } else {
            // this.sessionService.setData("userQualities", new Array<any>);
            const userQualitiesData = this.sessionService.getData("userQualities");
            const userQualitiesArray = userQualitiesData ? JSON.parse(userQualitiesData) : new Array<any>;
            this.listLikedQualities = userQualitiesArray;
            this.filtrarPlatosConCondiciones(this.listLikedQualities, copySections);
            this.modalService.dismissAll(this.miModal);
            this.modalService.dismissAll(this.modalProfile)
          }
          break;
        case 3:

          if (!bot) {
            this.filtraPlatosCualidadesFuncionales(this.moreFilter, copySections, bot);
          } else {
            this.filtraPlatosCualidadesFuncionales(cualidades, copySections, bot);
          }
          break;
        case 4:
          this.idDishToGo = 0;
          this.sections.forEach((sections: any) => {
            sections.Secciones.forEach((section: any) => {
              section.Platos = []
            });
          });


          const norm = (s: string) =>
            (s || '')
              .toLowerCase()
              .normalize('NFD').replace(/\p{Diacritic}/gu, '') // sin acentos
              .replace(/\s*\([^)]*\)/g, '')                    // quita ( ... )
              .replace(/\s+/g, ' ')                            // espacios
              .trim();

          const targets = nombres.map(norm); // ej. ["ristretto", "latte", ...]

          this.dishes = [];
          for (let i = 0; i < this.copyStorageSections.length; i++) {
            for (let j = 0; j < this.copyStorageSections[i].Secciones.length; j++) {
              for (let k = 0; k < this.copyStorageSections[i].Secciones[j].Platos.length; k++) {

                const plato = this.copyStorageSections[i].Secciones[j].Platos[k];
                const platoNorm = norm(plato.Nombre);

                if (targets.some(t => platoNorm.includes(t))) {
                  this.sections[i].Secciones[j].Platos.push(plato);
                  this.dishes.push(plato);
                  if (this.idDishToGo === 0) this.idDishToGo = this.sections[i].Secciones[j].Pos;
                }
              }
            }
          }
          this.isFilter = true;
          setTimeout(() => { }, 500)
          break;
      }
      this.loading = false;

      if (this.idDishToGo !== 0) {
        this.goSection(this.idDishToGo, 1);
      }
    }

  }

  setSectionDishes() {
    // Rebase SIEMPRE desde la copia completa (estado original) para evitar acumular filtros
    this.objDeleteFilters = [];
    this.loading = true;

    const source = (this.copyStorageSections && Array.isArray(this.copyStorageSections) && this.copyStorageSections.length)
      ? this.copyStorageSections
      : this.sections;

    const copySections = JSON.parse(JSON.stringify(source));

    // Limpia los platos visibles actuales para re-llenarlos con el resultado filtrado
    try {
      this.sections.forEach((sections: any) => {
        sections.Secciones.forEach((section: any) => {
          section.Platos = [];
        });
      });
    } catch { /* no-op */ }

    this.dishes = [];

    return copySections;
  }


  /**
   * Aplica todos los filtros activos en una sola pasada, partiendo SIEMPRE del catálogo base.
   * Mantiene this.sections y this.dishes sincronizados.
   */
  private applyAllFiltersUnified(): void {
    if (!this.ensureFilterDependencies()) return;

    const base = JSON.parse(JSON.stringify(this.copyStorageSections || []));
    const text = this.normalizeFilterText(this.searchName);
    const likedQualities = this.getLikedQualitiesForFilter();
    const seen = new Set<string>();

    this.sections = base;
    this.dishes = [];

    for (const group of this.sections) {
      for (const section of (group?.Secciones || [])) {
        section.Platos = (section?.Platos || []).filter((dish: any) => {
          const identity = this.productIdentity(dish);
          if (identity && seen.has(identity)) return false;

          const matches =
            this.matchesName(dish, text) &&
            this.matchesPrice(dish) &&
            this.matchesFavorite(dish) &&
            this.matchesLikedQualities(dish, likedQualities) &&
            this.matchesMoreFilters(dish);

          if (matches && identity) seen.add(identity);
          return matches;
        });
        this.dishes.push(...section.Platos);
      }
    }

    this.isFilter = this.hasActiveFilters;
    this.loading = false;
  }

  private ensureFilterDependencies(): boolean {
    if ((this.isFilterLike || this.isFilterQualities) && !this.userInformation?.email) {
      this.isFilterLike = false;
      this.isFilterQualities = false;
      this.toastr?.error(this.i18n.translate('messages.loginRequiredFilters'));
      this.modalLogin?.showModal();
      return true;
    }

    if (this.isFilterLike && !this.hasFavoriteCacheForCurrentScope()) {
      this.loadFavoriteIds(() => this.applyAllFiltersUnified());
      return false;
    }

    if (this.isFilterQualities && this.likedQualitiesCache === null) {
      const stored = this.readStoredLikedQualities();
      if (stored.length) {
        this.likedQualitiesCache = stored;
      } else if (!this.likedQualitiesRequestInFlight) {
        this.likedQualitiesRequestInFlight = true;
        this.userService.getLikedQualities(this.userInformation.email).subscribe({
          next: (response: any[]) => this.likedQualitiesCache = Array.isArray(response) ? response : [],
          error: () => this.likedQualitiesCache = [],
          complete: () => {
            this.likedQualitiesRequestInFlight = false;
            this.applyAllFiltersUnified();
          }
        });
        return false;
      } else {
        return false;
      }
    }

    return true;
  }

  private matchesName(dish: any, search: string): boolean {
    return !search || this.normalizeFilterText(dish?.Nombre).includes(search);
  }

  private matchesPrice(dish: any): boolean {
    if (!this.isFilterPrice) return true;
    const price = Number(dish?.Precio);
    if (!Number.isFinite(price)) return false;
    if (this.minPriceDish !== null && price < this.minPriceDish) return false;
    if (this.maxPriceDish !== null && price > this.maxPriceDish) return false;
    return true;
  }

  private matchesFavorite(dish: any): boolean {
    if (!this.isFilterLike) return true;
    const productId = Number(dish?.IDComercio);
    const matches = this.favoriteIdsCache.has(productId);
    if (matches) dish.Liked = true;
    return matches;
  }

  private matchesLikedQualities(dish: any, preferences: any[]): boolean {
    if (!this.isFilterQualities) return true;
    const qualities = this.getDishQualities(dish);
    if (!qualities.length || !preferences.length) return false;

    // The established behavior is OR: a product is accepted when it satisfies
    // at least one of the user's saved functional qualities.
    return preferences.some(preference => qualities.some((quality: any) =>
      this.matchesQualityPreference(quality, preference)));
  }

  private matchesQualityPreference(quality: any, preference: any): boolean {
    const preferenceId = Number(preference?.IdCualidad ?? preference?.qualityId);
    const qualityId = Number(quality?.Id ?? quality?.IdCualidad);
    const sameQuality =
      (Number.isFinite(preferenceId) && Number.isFinite(qualityId) && preferenceId === qualityId) ||
      this.normalizeFilterText(preference?.TipoUnidad) === this.normalizeFilterText(quality?.Nombre);
    if (!sameQuality) return false;

    const qualityValue = Number(quality?.Valor);
    const min = Number(preference?.min);
    const max = Number(preference?.max);
    const hasMin = Number.isFinite(min) && min !== 0;
    const hasMax = Number.isFinite(max) && max !== 0;
    if ((hasMin || hasMax) && Number.isFinite(qualityValue)) {
      return (!hasMin || qualityValue >= min) && (!hasMax || qualityValue <= max);
    }

    const expected = this.normalizeFilterText(preference?.Unidad ?? preference?.text);
    if (!expected) return true;
    const actualValue = this.normalizeFilterText(quality?.Valor);
    const actualDescription = this.normalizeFilterText(quality?.Desc);
    return expected === actualValue || expected === actualDescription;
  }

  private matchesMoreFilters(dish: any): boolean {
    if (!this.isFilterMore || !this.moreFilter.length) return true;
    const qualities = this.getDishQualities(dish);
    return this.moreFilter.every((filter: any) => qualities.some((quality: any) => {
      const nameMatches = this.normalizeFilterText(quality?.Nombre) === this.normalizeFilterText(filter?.cualidad);
      const description = this.normalizeFilterText(filter?.unidad);
      const value = this.normalizeFilterText(filter?.valor);
      return nameMatches &&
        (!description || this.normalizeFilterText(quality?.Desc) === description) &&
        (!value || this.normalizeFilterText(quality?.Valor) === value);
    }));
  }

  private getDishQualities(dish: any): any[] {
    if (Array.isArray(dish?.Cualidades)) return dish.Cualidades;
    if (Array.isArray(dish?.descCualidades)) return dish.descCualidades;
    return [];
  }

  private normalizeFilterText(value: any): string {
    return (value ?? '').toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  private validatePriceRange(): boolean {
    const min = this.minPriceDish;
    const max = this.maxPriceDish;
    if ((min !== null && (!Number.isFinite(min) || min < 0)) ||
        (max !== null && (!Number.isFinite(max) || max < 0))) {
      this.priceFilterError = 'filters.invalidPrice';
      return false;
    }
    if (min !== null && max !== null && min > max) {
      this.priceFilterError = 'filters.invalidRange';
      return false;
    }
    this.priceFilterError = '';
    return true;
  }

  private getLikedQualitiesForFilter(): any[] {
    return Array.isArray(this.likedQualitiesCache) ? this.likedQualitiesCache : [];
  }

  private readStoredLikedQualities(): any[] {
    try {
      const stored = this.sessionService.getData('userQualities');
      const parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private favoriteCacheKey(): string {
    return `${this.userInformation?.email || ''}:${this.getSelectedMenuIds().sort((a, b) => a - b).join(',')}`;
  }

  private hasFavoriteCacheForCurrentScope(): boolean {
    return this.favoriteScopeKey === this.favoriteCacheKey();
  }

  private invalidateFavoriteCache(): void {
    this.favoriteScopeKey = '';
    this.favoriteIdsCache.clear();
  }

  private loadFavoriteIds(onComplete?: () => void): void {
    if (!this.userInformation?.email || this.favoriteRequestInFlight) return;
    if (this.hasFavoriteCacheForCurrentScope()) {
      onComplete?.();
      return;
    }
    const menuIds = this.getSelectedMenuIds();
    const scopeKey = this.favoriteCacheKey();
    if (!menuIds.length) {
      this.favoriteIdsCache.clear();
      this.favoriteScopeKey = scopeKey;
      onComplete?.();
      return;
    }

    this.favoriteRequestInFlight = true;
    forkJoin(menuIds.map(menuId =>
      this.userService.getLikedProductsv2(this.userInformation.email, menuId).pipe(
        catchError(() => of(null))
      )
    )).subscribe({
      next: responses => {
        const ids = new Set<number>();
        for (const response of responses) {
          if (response === null) continue;
          try {
            const parsed = JSON.parse(this._crypto.decrypt(response as any));
            for (const item of (Array.isArray(parsed) ? parsed : [])) {
              const id = Number(item?.IdProducto ?? item?.IdPlato ?? item);
              if (Number.isFinite(id)) ids.add(id);
            }
          } catch { /* keep the other menu responses */ }
        }
        this.favoriteIdsCache = ids;
        this.favoriteScopeKey = scopeKey;
      },
      complete: () => {
        this.favoriteRequestInFlight = false;
        onComplete?.();
      }
    });
  }


  setDeleteFilter(value: number) {
    this.objDeleteFilters.push(value);
  }
  filtrarPlatosConCondiciones(condiciones: any, copySections: any) {

    for (let i = 0; i < copySections.length; i++) {
      for (let j = 0; j < copySections[i].Secciones.length; j++) {

        for (let k = 0; k < copySections[i].Secciones[j].Platos.length; k++) {


          const esValido = this.cumpleCondiciones(copySections[i].Secciones[j].Platos[k], condiciones);

          if (esValido) {
            this.sections[i].Secciones[j].Platos.push(copySections[i].Secciones[j].Platos[k]);
            this.dishes.push(copySections[i].Secciones[j].Platos[k])
          }
        }
      }
    }
  }

  filtraPlatosCualidadesFuncionales(condiciones: any, copySections: any, bot: boolean = false) {
    for (let i = 0; i < copySections.length; i++) {
      for (let j = 0; j < copySections[i].Secciones.length; j++) {

        for (let k = 0; k < copySections[i].Secciones[j].Platos.length; k++) {
          const esValido = this.cumpleCondicionesMasFiltros(copySections[i].Secciones[j].Platos[k], condiciones, bot);
          if (esValido) {
            this.sections[i].Secciones[j].Platos.push(copySections[i].Secciones[j].Platos[k]);
            this.dishes.push(copySections[i].Secciones[j].Platos[k])
          }
        }
      }
    }
  }
  cumpleCondiciones(plato: any, condiciones: any) {
    let cumpleAlMenosUna = false;
    condiciones.forEach((condicion: any) => {
      if (plato.descCualidades) {
        const condicionPlato = plato.descCualidades.find((c: any) => c.Id === condicion.IdCualidad);

        if (condicionPlato) {
          if (condicion.min !== 0 && condicion.max !== 0) {
            const valorPlato = parseFloat(condicionPlato.Valor);

            if (!isNaN(valorPlato) && valorPlato >= condicion.min && valorPlato <= condicion.max) {
              cumpleAlMenosUna = true;
            }
          } else if (condicionPlato.Valor === condicion.Unidad) {
            cumpleAlMenosUna = true;
          }
        }
      }
    });

    return cumpleAlMenosUna;
  }

  cumpleCondicionesMasFiltros(plato: any, condiciones: any, bot: boolean = false) {
    let cumpleAlMenosUna = false;
    condiciones.forEach((condicion: any) => {
      if (!bot) {
        if (condicion.unidad == "-")
          condicion.unidad = 'No';
      }

      if (plato.descCualidades) {
        let condicionPlato: boolean = false;

        if (!bot) {
          condicionPlato = plato.descCualidades.find((c: any) => c.Nombre === condicion.cualidad && c.Desc == condicion.unidad && c.Valor == condicion.valor);
        } else {
          plato.descCualidades.forEach((element: any) => {
            const cadena1Lower = element.Nombre.toLowerCase();
            const cadena2Lower = element.Desc.toLowerCase();
            const condition = condicion.name.slice(0, condicion.name.length - 2);

            if (cadena1Lower.includes(condition) || cadena2Lower.includes(condition)) {
              if (condicion.value == 'sí' || condicion.value == 'no') {
                if (element.Valor.toLowerCase().includes(condicion.value.slice(0, condicion.value.length - 1))) {

                  condicionPlato = true;
                } else {

                  condicionPlato = false;
                }
              }

              if (!isNaN(condicion.value) && (parseFloat(element.Valor) <= parseFloat(condicion.value))) {
                condicionPlato = true;
              }
            }
          });
        }

        if (condicionPlato) {
          cumpleAlMenosUna = true;
        }
      }
    });
    return cumpleAlMenosUna;
  }

  deleteFilter(op: number) {
    switch (op) {
      case 0:
        this.searchName = '';
        this.isFilterText = false;
        break;
      case 1:
        this.isFilterLike = false;
        break;
      case 2:
        this.isFilterQualities = false;
        break;
      case 3:
        this.isFilterPrice = false;
        this.changeMinMax = false;
        this.minPriceDish = null;
        this.maxPriceDish = null;
        this.priceFilterError = '';
        break;
      case 4:
        this.isFilterMore = false;
        this.moreFilter = [];
        break;
    }
    this.applyAllFiltersUnified();
  }

  cleanFilterItems() {
    this.sections.forEach((sections: any) => {
      sections.Secciones.forEach((section: any) => {
        section.Platos = []
      });
    });
    this.dishes = [];

    for (let i = 0; i < this.copyStorageSections.length; i++) {
      for (let j = 0; j < this.copyStorageSections[i].Secciones.length; j++) {
        for (let k = 0; k < this.copyStorageSections[i].Secciones[j].Platos.length; k++) {
          this.sections[i].Secciones[j].Platos.push(this.copyStorageSections[i].Secciones[j].Platos[k]);
          this.dishes.push(this.copyStorageSections[i].Secciones[j].Platos[k])
        }
      }
    }
  }

  cleanFilter() {
    this.idDishToGo = 0;
    this.searchName = '';
    this.isFilter = false;
    this.isFilterQualities = false;
    this.isFilterLike = false;
    this.isFilterText = false;
    this.isFilterPrice = false;
    this.isFilterMore = false;
    this.moreFilter = [];
    this.changeMinMax = false;
    this.minPriceDish = null;
    this.maxPriceDish = null;
    this.priceFilterError = '';
    this.getLikes();
    this.objFilters = [];
    this.objDeleteFilters = [];
    this.applyAllFiltersUnified();
  }

  getUrlImage(url: string) {
    const imagen = url.replace('https://bravum.cl/assets/Images/', './assets/Images/');

    return imagen;
  }

  setCheckedMenu() {
    this.menu.forEach((element: any) => {
      element.check = false;
    });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    // Throttle con rAF para suavizar
    if (this._rafLock) return;
    this._rafLock = true;
    requestAnimationFrame(() => {
      this._rafLock = false;
      this.handleScrollWork();
    });
  }

  private handleScrollWork(): void {
    const scrollY = window.pageYOffset + 400;
    this.isfixed = window.pageYOffset >= 500;

    this.icons.forEach((icon: any, idx: number) => {
      const sectionId = 'sec-' + icon.id;
      const sectionEl = document.getElementById(sectionId);
      const iconEl = document.getElementById(icon.id);
      if (!sectionEl || !iconEl) return;

      const offsetTop = sectionEl.offsetTop + 315;
      const offsetHeight = sectionEl.offsetHeight;
      const isActive = scrollY > offsetTop && scrollY <= offsetTop + offsetHeight;

      if (isActive) {
        iconEl.classList.add('icon-text');
        this.idIcon = icon.id;
        this.centerIconInCarousel(idx); // 👈 mueve horizontalmente el carrusel
      } else {
        iconEl.classList.remove('icon-text');
      }

      icon.activated = isActive;
    });
  }

  /** Desplaza el carrusel para centrar el ícono con índice `index` */
  private centerIconInCarousel(index: number): void {
    const scroller = this.scrollerRef?.nativeElement;
    const iconEl = this.iconItems?.get(index)?.nativeElement;
    if (!scroller || !iconEl) return;

    // El contenedor que “scrollea” horizontalmente suele ser el padre directo del item.
    // Si `drag-scroll` envuelve más, usa `closest` para encontrar el primer contenedor con overflow-x.
    const scrollContainer =
      this.findScrollableXContainer(iconEl) ?? scroller;

    const itemLeft = iconEl.offsetLeft;
    const itemWidth = iconEl.offsetWidth;
    const containerWidth = scrollContainer.clientWidth;

    const targetLeft = Math.max(
      0,
      itemLeft - (containerWidth - itemWidth) / 2
    );

    scrollContainer.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }

  /** Busca el primer contenedor con overflow-x que pueda hacer scroll */
  private findScrollableXContainer(startEl: HTMLElement): HTMLElement | null {
    let el: HTMLElement | null = startEl.parentElement;
    while (el && el !== document.body) {
      const style = getComputedStyle(el);
      const canScrollX =
        (/(auto|scroll)/i).test(style.overflowX) || el.scrollWidth > el.clientWidth;
      if (canScrollX) return el;
      el = el.parentElement;
    }
    return null;
  }


  noFood(idSection: number, idSections: number, idPlato: number) {
    this.sections[idSection].Secciones[idSections].Platos[idPlato].Foto = "/assets/img/no-food.png";
  }

  setLike(idSection: number, idSections: number, idPlato: number) {
    if (this.userInformation !== null) {
      let dish = this.sections[idSection].Secciones[idSections].Platos[idPlato];
      let data = new LikedProducts("", 0, 0, true);
      data.sndevice = this.userInformation.email;
      data.menuId = Number(dish?._menuId || this.menudId);
      data.productId = dish.IDComercio;
      data.status = dish.Liked ? false : true;

      if (dish.Liked) {
        dish.Liked = false;
      } else {
        dish.Liked = true;
      }

      const indexedDish = this.dishes.find((x: any) => x.IDComercio === dish.IDComercio);
      if (indexedDish) indexedDish.Liked = dish.Liked;
      this.setLikesDish(dish.IDComercio, dish.Liked);

      this.userService.setLikedProductsv2(data).subscribe(() => {
        this.invalidateFavoriteCache();
        this.getLikes();
      });
    } else {
      this.toastr.error(this.i18n.translate('messages.loginRequiredAction'));
    }
  }

  setLikeModalDish(dish: any) {
    if (this.userInformation !== null) {
      let data = new LikedProducts("", 0, 0, true);
      data.sndevice = this.userInformation.email;
      data.menuId = Number(dish?._menuId || this.menudId);
      data.productId = dish.IDComercio;
      data.status = dish.Liked ? false : true;

      if (dish.Liked) {
        dish.Liked = false;
      } else {
        dish.Liked = true;
      }

      const indexedDish = this.dishes.find((x: any) => x.IDComercio === dish.IDComercio);
      if (indexedDish) indexedDish.Liked = dish.Liked;
      this.setLikesDish(dish.IDComercio, dish.Liked);

      this.userService.setLikedProductsv2(data).subscribe(() => {
        this.invalidateFavoriteCache();
        this.getLikes();
      });
    } else {
      this.toastr.error(this.i18n.translate('messages.loginRequiredAction'));
    }
  }

  setLikesDish(idPlato: any, liked: boolean) {
    this.sections.forEach((section: any) => {
      section.Secciones.forEach((section: any) => {
        section.Platos.forEach((dish: any) => {
          if (dish.IDComercio == idPlato) {
            dish.Liked = liked;
            const indexedDish = this.dishes.find((x: any) => x.IDComercio === idPlato);
            if (indexedDish) indexedDish.Liked = liked;
          }
        });
      });
    });
  }


  getLikes(onComplete?: () => void) {
    if (!this.userInformation?.email) {
      onComplete?.();
      return;
    }

    this.loadFavoriteIds(() => {
      const applyLikedState = (groups: any[]) => {
        for (const group of (groups || [])) {
          for (const section of (group?.Secciones || [])) {
            for (const dish of (section?.Platos || [])) {
              dish.Liked = this.favoriteIdsCache.has(Number(dish?.IDComercio));
            }
          }
        }
      };
      applyLikedState(this.copyStorageSections);
      applyLikedState(this.sections);
      this.rebuildVisibleDishIndex();
      if (this.isFilterLike) this.applyAllFiltersUnified();
      onComplete?.();
    });
  }

  detailDish(idDish: number) {
    const indexPlato = this.dishes.findIndex((x: any) => Number(x.IdPlato) === Number(idDish));
    if (indexPlato < 0) return;

    this.selectedDish = this.dishes[indexPlato];
    this.recommendationPublicationId = 0;
    this.loadProductRecommendations(this.selectedDish);
    const modalRef = this.modalService.open(this.modalPlatos, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      windowClass: 'dish-detail-modal'
    });
    this.dishModalRef = modalRef;

    modalRef.hidden.subscribe(() => this.clearProductRecommendations(modalRef));

    modalRef.shown.subscribe(() => {
      this.goToDishSlide(indexPlato);
    });
  }

  afterChange(e: { currentSlide: number }) {
    const total = this.dishes?.length ?? 0;
    if (!total) return;

    // Normaliza el índice para ignorar clones
    const realIndex = ((e.currentSlide % total) + total) % total;

    const plato = this.dishes[realIndex];
    if (!plato) return;

    this.selectedDish = plato;
    this.loadProductRecommendations(plato);

    const elementId = 'dish-' + plato.IdPlato;

    // Pequeño delay por layout en móvil
    setTimeout(() => {
      const el = document.getElementById(elementId);
      if (!el) return;

      // Algunos móviles no respetan block:'center'
      try {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch {
        const scroller = this.findScrollableAncestor(el) || el.parentElement;
        if (scroller) {
          scroller.scrollTo({
            top: el.offsetTop - (scroller.clientHeight / 2),
            behavior: 'smooth'
          });
        }
      }
    }, 80);
  }

  private loadProductRecommendations(dish: any): void {
    const idPublicacion = Number(dish?.IdPlato);
    if (!Number.isInteger(idPublicacion) || idPublicacion <= 0) return;
    if (this.recommendationPublicationId === idPublicacion) return;

    this.recommendationRequest$.next();
    this.recommendationPublicationId = idPublicacion;
    this.productRecommendations = [];
    this.recommendationsLoading = true;

    const request: ProductRecommendationRequest = {
      idPublicacion,
      context: {
        idRestaurant: Number(this.idRestaurant),
        idMenu: Number(this.itemMenu?.idCarta || this.idMenu || 0),
        option: Number(this.option),
        preferredLanguage: this.preferredLanguage,
        selectedMenuIds: this.getSelectedChatMenuIds()
      }
    };

    this.openAi.getProductRecommendations(request)
      .pipe(takeUntil(this.destroy$), takeUntil(this.recommendationRequest$))
      .subscribe({
        next: response => {
          if (this.recommendationPublicationId !== idPublicacion) return;
          this.productRecommendations = response?.available
            ? (response.recommendations || []).filter(item => Number(item.idPublicacion) !== idPublicacion)
            : [];
          this.recommendationsLoading = false;
        },
        error: () => {
          if (this.recommendationPublicationId !== idPublicacion) return;
          this.productRecommendations = [];
          this.recommendationsLoading = false;
        }
      });
  }

  viewRecommendedProduct(recommendation: ProductRecommendation): void {
    const index = this.dishes.findIndex((dish: any) =>
      Number(dish?.IdPlato) === Number(recommendation.idPublicacion));
    if (index < 0) return;

    this.goToDishSlide(index);
  }

  private goToDishSlide(index: number): void {
    if (this.dishCarousel) {
      this.dishCarousel.slickGoTo(index);
      return;
    }

    // El contenido del TemplateRef se renderiza fuera de la vista del componente
    // cuando NgbModal lo abre, por lo que ViewChild puede no resolver el carrusel.
    const slickElement = document.querySelector('#carrusel-slick') as any;
    slickElement?.slick?.slickGoTo(index);
  }

  hasRecommendationImage(item: ProductRecommendation): boolean {
    const imageUrl = typeof item?.imagen === 'string' ? item.imagen.trim() : '';
    return imageUrl.length > 0 && !this.failedDishImages.has(imageUrl);
  }

  onRecommendationImageError(item: ProductRecommendation): void {
    const imageUrl = typeof item?.imagen === 'string' ? item.imagen.trim() : '';
    if (imageUrl) this.failedDishImages.add(imageUrl);
  }

  private clearProductRecommendations(modalRef: NgbModalRef): void {
    if (this.dishModalRef !== modalRef) return;
    this.recommendationRequest$.next();
    this.dishModalRef = undefined;
    this.recommendationPublicationId = 0;
    this.productRecommendations = [];
    this.recommendationsLoading = false;
    this.selectedDish = null;
  }

  /** Busca el contenedor que realmente hace scroll (útil en móvil) */
  findScrollableAncestor(el: HTMLElement | null): HTMLElement | null {
    let n = el?.parentElement;
    while (n) {
      const style = getComputedStyle(n);
      const oy = style.overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) {
        return n;
      }
      n = n.parentElement!;
    }
    return null;
  }



  goSection(id: number, option: number) {
    setTimeout(() => {
      var idsect = "sec-" + id;
      const element = this.el.nativeElement.querySelector(`#${idsect}`);
      if (element) {
        let offset = 0;
        switch (option) {
          case 1:
            offset = element.offsetTop - 110;
            window.scrollTo({ top: offset, behavior: 'smooth' });

            break;
          case 2:
            offset = element.offsetTop - 110;
            window.scrollTo({ top: offset, behavior: 'smooth' });
            break;
        }
      }

    }, 200);
  }

  goDish(idDish: number) {
    if (!this.didIt) {
      setTimeout(() => {
        var id = "#dish-" + idDish;
        document.querySelector(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        let bodyRect: any;
        bodyRect = document.querySelector(id)?.getBoundingClientRect();

        let total = bodyRect?.top - 180;
        window.scrollTo({
          top: total,
          behavior: 'smooth'
        });
      }, 80);

      this.didIt = true;

    }

  }

  changeCualidad(value: any) {
    this.maxValue = 0;
    this.minValue = 0;
    let values: Array<string> = value.value.split("-");

    this.showBooleanValue = false;
    this.showTextValue = false;
    this.showRangeValue = false;

    this.filterUnidades = this.unidades.filter((x: any) => x.IdUnidad == values[0]);
    if (this.filterUnidades) {
      this.unidad = this.filterUnidades[0].UnidadDeMedida;
      this.idUnidadPersonal = this.filterUnidades[0].Id;
      this.maxValue = this.filterUnidades[0].Maximo;
      this.minValue = this.filterUnidades[0].Minimo;
      this.max = this.maxValue;
      this.min = this.minValue;

    }


    this.IdTipoUnidadMedida = Number.parseInt(values[0]);

    if (Number.parseInt(values[0]) == 1) {
      this.showBooleanValue = true;
      this.hasValues = false;
    }

    if (Number.parseInt(values[0]) == 2) {
      this.showTextValue = true;
    }

    if (Number.parseInt(values[0]) >= 3) {
      this.showRangeValue = true;
    }


    this.cualidad = values[2];
  }

  changeUnidad(value: any) {
    let splitElement = value.value.split("*")

    this.idUnidadPersonal = splitElement[1];
    this.maxValue = splitElement[2];
    this.minValue = splitElement[3];
    this.unidad = splitElement[0];
    this.max = this.maxValue;
    this.min = this.minValue;
  }

  setValueRange(value: any, op: number) {
    this.hasValues = true;
    switch (op) {
      case 1:
        this.minValue = value.value;
        break;
      case 2:
        this.maxValue = value.value;
        break;
    }
  }

  setValueCua(value: any, op: number) {
    switch (op) {
      case 1:
        this.min = value.value;
        break;
      case 2:
        this.max = value.value;
        break;
    }
  }


  closeMenu() {
    setTimeout(this.closeAddExpenseModal.nativeElement.click(), 4000);
    setTimeout(this.closeModal.nativeElement.click(), 4000);
  }


  openModal(content: any, isInvitatedUser: boolean = false) {
    this.isInvitatedUser = isInvitatedUser;
    if (isInvitatedUser) {
      this.userInformation = JSON.parse(this.sessionService.getData('invitatedUserInformation'));
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });

    } else {
      this.userInformation = JSON.parse(this.sessionService.getData('userInformation'));
      if (this.userInformation === null) {
        this.modalLogin.showModal(); // Llama a la función showModal del componente secundario
      } else {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
      }
    }


    this.monedaUser = this.userInformation.moneyType;
    this.idiomaUser = menuLanguageId(this.menuLanguageService.getPreference(this.userInformation?.lenguajeType).preferredLanguage);

  }

  openModalMoreFilter(content: any, event: Event) {
    this.showDropdownMenu = false;

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
  }


  deleteProfile() {
    if (!this.isInvitatedUser) {
      this.sessionService.clearData("userInformation");
      this.sessionService.clearData("showModal");
      this.toastr.success(this.i18n.translate('profile.signedOut'));
      this.isInvitatedUser = true;
    } else {
      this.sessionService.clearData("invitatedUserInformation");
      this.sessionService.clearData("userQualities");
      this.toastr.success(this.i18n.translate('profile.saved'));
    }
    this.modalService.dismissAll(this.modalProfile);

    location.reload();
  }

  openBackDropCustomClass(content: any) {
    this.modalService.open(content, { centered: true, backdropClass: 'light-blue-backdrop', scrollable: true }).result.then((result) => {

    }, (reason) => {

    });
    this.listLikedQualities = [];
    if (!this.isInvitatedUser) {
      this.userService.getLikedQualities(this.userInformation.email).subscribe((response: Array<ListLikedQualities>) => {
        if (response) {
          this.listLikedQualities = response;
        } else {
          this.toastr.error(this.i18n.translate('menu.none'));
        }
      });
    } else {
      // this.sessionService.setData("userQualities", new Array<any>);
      const userQualitiesData = this.sessionService.getData("userQualities");
      const userQualitiesArray = userQualitiesData ? JSON.parse(userQualitiesData) : new Array<any>;
      this.listLikedQualities = userQualitiesArray;
    }
  }

  dismissModal(modal: any) {
    this.modalService.dismissAll(modal);
  }

  setPersonalQualitys() {
    let personalQuality = {
      cualidad: 0,
      unidad: 0,
      valor: ""
    };



    if (!this.showBooleanValue) {
      personalQuality.cualidad = parseInt(this.cualidad);
      personalQuality.unidad = this.idUnidadPersonal;
      personalQuality.valor = this.minValue + "-" + this.maxValue;
    } else {
      personalQuality.cualidad = parseInt(this.cualidad);
      personalQuality.unidad = this.idUnidadPersonal;
      personalQuality.valor = this.unidad;
    }

    const likedQuality = new LikedQualities();
    likedQuality.qualityId = personalQuality.cualidad;
    likedQuality.unityMesureId = personalQuality.unidad;
    likedQuality.email = this.userInformation.email;
    likedQuality.max = !this.showBooleanValue ? this.max : 0;
    likedQuality.min = !this.showBooleanValue ? this.min : 0;
    likedQuality.text = !this.showBooleanValue ? "" : personalQuality.valor;
    likedQuality.logic = this.showBooleanValue ? true : false;
    likedQuality.status = true;
    this.loading = true;

    if (!this.isInvitatedUser) {
      this.userService.setLikedQualities(likedQuality).subscribe((response: boolean) => {
        this.loading = false;
        if (response) {
          this.toastr.success(this.i18n.translate('profile.saved'));
          this.userService.getLikedQualities(this.userInformation.email).subscribe((response: Array<ListLikedQualities>) => {
            if (response) {
              this.listLikedQualities = response;
            } else {
              this.toastr.error(this.i18n.translate('menu.none'));
            }
          });
        } else {
          this.toastr.error(this.i18n.translate('messages.genericError'));
        }
      });
    } else {
      //cualidades
      const cualidad = this.cualidades.filter((x: any) => x.Id == likedQuality.qualityId);
      const unidad = this.filterUnidades.filter((x: any) => x.Id == likedQuality.unityMesureId);
      let objQualities = {
        IdCualidad: likedQuality.qualityId,
        IdUnidad: likedQuality.unityMesureId,
        TipoUnidad: cualidad[0].Nombre,
        Unidad: unidad[0].UnidadDeMedida,
        logic: likedQuality.logic,
        max: likedQuality.max,
        min: likedQuality.min,
        text: likedQuality.text
      }

      try {
        const userQualitiesData = this.sessionService.getData("userQualities");
        const userQualitiesArray = userQualitiesData ? JSON.parse(userQualitiesData) : new Array<any>;

        userQualitiesArray.push(objQualities);
        this.listLikedQualities = userQualitiesArray;
        this.sessionService.setData("userQualities", JSON.stringify(userQualitiesArray));

        setTimeout(() => {
          this.loading = false;
          this.toastr.success(this.i18n.translate('profile.saved'));
        }, 300);
        // Ahora userQualitiesArray es un arreglo de JavaScript
      } catch (error) {
        this.toastr.error(this.i18n.translate('messages.genericError'));
      }
    }

  }

  deleteMyQuality(item: any) {


    const likedQuality = new LikedQualities();
    likedQuality.qualityId = item.IdCualidad;
    likedQuality.unityMesureId = item.IdUnidad;
    likedQuality.email = this.userInformation.email;
    likedQuality.status = false;

    this.loading = true;

    if (!this.isInvitatedUser) {
      this.userService.setLikedQualities(likedQuality).subscribe((response: boolean) => {
        this.loading = false;
        if (response) {
          this.toastr.success(this.i18n.translate('profile.saved'));
          this.userService.getLikedQualities(this.userInformation.email).subscribe((response: Array<ListLikedQualities>) => {
            if (response) {
              this.listLikedQualities = response;
            } else {
              this.toastr.error(this.i18n.translate('menu.none'));
            }
          });
        } else {
          this.toastr.error(this.i18n.translate('messages.genericError'));
        }
      });
    } else {
      const userQualitiesData = this.sessionService.getData("userQualities");
      const userQualitiesArray = userQualitiesData ? JSON.parse(userQualitiesData) : new Array<any>;

      const itemQualityIndex = userQualitiesArray.findIndex((x: any) => x.IdCualidad == item.IdCualidad && x.IdUnidad == item.IdUnidad);
      userQualitiesArray.splice(itemQualityIndex, 1);

      this.listLikedQualities = userQualitiesArray;
      this.sessionService.setData("userQualities", JSON.stringify(userQualitiesArray));

      setTimeout(() => {
        this.loading = false;
        this.toastr.success(this.i18n.translate('profile.saved'));
      }, 300);
    }
  }




  saveGeneralConfiguration() {
    let data = new TempUser();

    data.email = this.isInvitatedUser ? "" : this.userInformation.email;
    data.moneyType = this.monedaUser;
    data.lenguajeType = this.idiomaUser;
    this.menuLanguageService.setExplicitPreference(resolveMenuLanguage(this.idiomaUser));
    data.invitatedUser = false;
    this.loading = true;

    if (this.isInvitatedUser) {
      this.sessionService.setData('invitatedUserInformation', JSON.stringify(data));
      this.userInformation = data;
      this.modalService.dismissAll(this.modalProfile);
      this.getMenu(resolveMenuLanguage(this.idiomaUser));
    } else {
      this.userService.editTemporalUser(data).subscribe((response: any) => {

        if (!response.error) {
          this.toastr.success(this.i18n.translate('profile.saved'));
          this.sessionService.setData('userInformation', JSON.stringify(response.Response));
          this.userInformation = response.Response;
          this.modalService.dismissAll(this.modalProfile);
          this.getMenu(resolveMenuLanguage(this.idiomaUser));
        } else {
          this.toastr.error(this.i18n.translate('messages.genericError'));
          this.loading = false;
        }
      });
    }



  }


  getBackgroundStyle(imageUrl: string | undefined) {
    imageUrl = imageUrl?.replace('https://bravum.cl/Images', 'assets/Images');
    const backgroundImage = imageUrl ? `url(${this.getUrlImage(imageUrl)})` : 'url(https://placehold.it/70x70)';

    return {
      'background': backgroundImage,
      'background-repeat': 'no-repeat',
      'background-size': '140px',
      'background-position': 'left center',
      'width': '140px',
      'height': '140px',
      'margin': 'auto',
      'border-radius': '15px',
      'position': 'relative'
    };
  }

  failedDishImages = new Set<string>();

  hasDishImage(item: any): boolean {
    const imageUrl = typeof item?.Foto === 'string' ? item.Foto.trim() : '';
    return imageUrl.length > 0 && !this.failedDishImages.has(imageUrl);
  }

  onDishImageError(item: any): void {
    const imageUrl = typeof item?.Foto === 'string' ? item.Foto.trim() : '';
    if (imageUrl) this.failedDishImages.add(imageUrl);
  }


  onInputChange(event: Event): void {
    const valor = (event.target as HTMLInputElement).value;
    this.searchName = valor;
    this.isFilterText = this.normalizeFilterText(valor).length > 0;
    this.applyAllFiltersUnified();
  }

  toggleFilters(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.showDropdownMenu = !this.showDropdownMenu;
  }

  closeFilters(): void {
    this.showDropdownMenu = false;
  }

  @HostListener('document:click', ['$event'])
  closeFiltersOnOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    if (this.showDropdownMenu && !target?.closest('.filter-dropdown')) this.closeFilters();
  }

  @HostListener('document:keydown.escape')
  closeFiltersOnEscape(): void {
    this.closeFilters();
  }

  toggleChat() {
    this.isOpenChat = !this.isOpenChat;
    this.scrollToBottom();
  }

  hiddeToggleChat() {
    this.isOpenChat = false;
  }

  callGTP(mensaje: string) {
    this.ensureChatContext();
    const request = {
      message: mensaje,
      context: {
        idRestaurant: Number(this.idRestaurant),
        idMenu: Number(this.idMenu || 0),
        option: Number(this.option),
        preferredLanguage: this.preferredLanguage,
        selectedMenuIds: this.getSelectedChatMenuIds()
      },
      history: this.chatHistory.slice(-8)
    };

    this.openAi.sendMessage(request).subscribe({
      next: (response: ChatResponse) => {
        this.conversation = this.conversation.filter(m => !m.loading);

        const reply = response?.message?.trim() || this.i18n.translate('chat.noContent');
        const products = Array.isArray(response?.products) ? response.products : [];
        this.conversation.push({ sender: 'server', message: reply, type: 2, products });
        this.chatHistory.push(
          { role: 'user', content: mensaje.slice(0, 1000) },
          { role: 'assistant', content: reply.slice(0, 1000) }
        );
        this.chatHistory = this.chatHistory.slice(-8);

        this.scrollToBottom();
      },
      error: (err) => {
        this.conversation = this.conversation.filter(m => !m.loading);
        this.conversation.push({ sender: 'server', message: '', translationKey: this.chatErrorTranslationKey(err), type: 2 });
        this.scrollToBottom();
      }
    });
  }

  private chatErrorTranslationKey(error: any): string {
    if (Number(error?.status) === 0) return 'chat.connectionError';
    if (Number(error?.status) === 429
      || error?.error?.code === 'RateLimited') return 'chat.temporarilyUnavailable';
    if ([503, 504].includes(Number(error?.status))) return 'chat.temporarilyUnavailable';
    return 'chat.processingError';
  }

  private getSelectedChatMenuIds(): number[] {
    if (Number(this.option) === 0) {
      return (this.objCheckedMenu || [])
        .map((id: any) => Number(id))
        .filter((id: number) => Number.isInteger(id) && id > 0);
    }

    const id = Number(this.itemMenu?.idCarta || this.idMenu || 0);
    return id > 0 ? [id] : [];
  }

  private ensureChatContext(): void {
    const signature = JSON.stringify({
      restaurant: Number(this.idRestaurant),
      menu: Number(this.idMenu || 0),
      option: Number(this.option),
      language: this.preferredLanguage,
      selected: this.getSelectedChatMenuIds().slice().sort((a, b) => a - b)
    });

    if (this.chatContextSignature && this.chatContextSignature !== signature) {
      this.chatHistory = [];
    }
    this.chatContextSignature = signature;
  }

  openChatProduct(product: ChatProduct): void {
    const dish = this.dishes.find((item: any) => Number(item.IdPlato) === Number(product.idPublicacion));
    if (!dish) {
      this.toastr.info(this.i18n.translate('chat.dishLoading'));
      return;
    }
    this.detailDish(dish.IdPlato);
  }

  callGPTImages(image: string) {
    this.openAi.lookForImages(image).subscribe((response: any) => {
      if (response) {
        if (response.choices[0].message.content == "null") {
          this.conversation = this.conversation.filter(msg => msg.translationKey !== 'chat.searching');
          this.conversation.push({ sender: 'server', message: '', translationKey: 'chat.noContent', type: 1 });
          this.scrollToBottom();
        } else {
          setTimeout(() => { }, 500);
          this.conversation = this.conversation.filter(msg => msg.translationKey !== 'chat.searching');
          var cleanText = response.choices[0].message.content.replace(/'/g, '"');
          const object: OpenAIImage = JSON.parse(cleanText)
          this.scrollToBottom();


          this.conversation.push({ sender: 'server', message: '', translationKey: 'chat.imageResult', type: 2 });

          if (object.Product) {
            this.searchName = object.Product;
            this.setFilters(0);
          }

        }

      }
    });
  }

  sendMessage() {
    if (this.messagechat.trim() !== '') {
      const message = this.messagechat;
      this.conversation.push({ sender: 'user', message, type: 1 });
      this.conversation.push({ sender: 'server', message: '', translationKey: 'chat.searching', type: 1, loading: true });
      this.messagechat = '';
      this.callGTP(message);
      this.scrollToBottom();
    }
  }

  scrollToBottom(): void {
    setTimeout(() => {
      try {
        this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
      } catch (err) { }
    });
  }

  onOverlayClick(event: MouseEvent) {
    // Verificar si el clic fue fuera del chat-container
    const target = event.target as HTMLElement;
    if (!target.closest('.chat-container')) {
      this.isOpenChat = false;
    }
  }
  toggleDropdownMenu() {
    this.showDropdownMenu = true;

    this.modalService.dismissAll(this.modalMoreFiltes);
  }

  onFileInputClick(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(input.files[0]); // read file as data url

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.urlImg = event.target.result.toString();

        this.conversation.push({ sender: 'user', message: "", type: 3 });
        this.conversation.push({ sender: 'server', message: '', translationKey: 'chat.searching', type: 1 });
        this.callGPTImages(this.urlImg);
      }
    }
  }

  filtrarPlatosPorNombre(nombres: string[]) {
    const copySections = JSON.parse(JSON.stringify(this.sections));
    this.sections.forEach((sections: any) => {
      sections.Secciones.forEach((section: any) => {
        section.Platos = []
      });
    });
  }

  addToCart(dish: any) {
    let objProduct = new ProductsCart();
    objProduct.id_product = dish.IDComercio;
    objProduct.name_product = dish.Nombre;
    objProduct.price_product = dish.Precio;
    objProduct.amount_product = 1;

    this.cart.products.push(objProduct)
  }


  trackByCualidad(index: number, cualidad: any): any {
    return cualidad?.Id || index;
  }
  trackByDish(index: number, dish: any): number {
    return dish.IdPlato;
  }
  trackByIcon(index: number, icon: any): any { return icon?.id ?? index; }

}
